import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { withRouter } from 'next/router'

import SEO from 'seo/page'
import {
  AppButtons,
  Copy,
  Image,
  PhoneNumber,
} from 'components/Molecules/DownloadApp'
import { Grid as Template } from 'components/Templates'
import { getAppName } from 'models/application'

const Screen = props => {
  const { application, router } = props

  return (
    <Template
      showBackButton={!router?.query?.hideBackButton}
      noBackButtonBorder
      application={application}>
      <SEO title={`Download the Citifyd App | ${getAppName(application)}`} />
      <Row reverse={true}>
        <Col sm={6} smOffset={1} xs={12}>
          <Copy type={router?.query?.type} />
          <PhoneNumber token={router?.query?.token} />
          <AppButtons />
        </Col>
        <Col sm={5} xs={12}>
          <Image />
        </Col>
      </Row>
    </Template>
  )
}

Screen.propTypes = {
  application: PropTypes.string,
  router: PropTypes.object,
}

export default withRouter(Screen)
